import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labMasterTradeRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/trades/master_trades/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/lab/Trades/LabMasterTrades/LabMasterTradePage/LabMasterTradePage').then(
    (d) => d.Route
  )
);
